import { useGetSpaces } from '@/entities/teamspace';
import { useCurrentUser, useSettings } from '@/entities/user/currentUser';

export const useCanCreateSpace = () => {
  const { data: userId } = useCurrentUser((user) => user?.id);
  const settings = useSettings();
  const spaces = useGetSpaces();

  const ownSpacesCount = spaces?.data?.filter((space) => space.owner_id === userId).length ?? 0;

  return ownSpacesCount < (settings.scope_settings.available_features.spaces.metadata.limit ?? 0);
};
